<template>
  <v-container  justify="center">
    <img width="250"  :src="'https://managers.winlift.gr/subdomains/'+subdomain+'.png'">

    <v-row align="top" >
      <v-col lg="4">
        <v-card >
          <v-card-text>
            <v-alert outlined dismissible class="mt-5" type="error" v-if="error"> Λάθος συνδιασμός όνομα
              χρήστη και κωδικού
            </v-alert>
            <v-form>
              <v-text-field label="Όνομα Χρήστη" v-model="username" type="text"/>
              <v-text-field label="Κωδικός" v-model="password" type="password" hide-details/>
              <v-checkbox v-model="rememberMe" :value="true" label="Να παραμείνω σε σύνδεση"/>
              <v-btn color="primary" large @click="login"> Σύνδεση</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <front-page-info></front-page-info>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapActions, mapState} from 'vuex';
import FrontPageInfo from '../components/FrontPageInfo.vue';
import InstallButton from "../components/InstallButton.vue";

export default {
  name: "Login",
  components:{InstallButton, FrontPageInfo},
  data: () => ({
    error: false,
    username: "",
    password: "",
    rememberMe: false
  }),
  computed:{
    ...mapState([
        'subdomain'
    ])
  },
  methods: {
    ...mapActions([
      "getSubscriptionDetails"
    ]),
    login() {
      this.error = false;
      this.getSubscriptionDetails(
          {
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
          }).then(
          (user) => {
            if (!this.$route.query.from) this.$router.push('/');
            this.$router.replace(this.$route.query.from);
          },
      ).catch(err => {
        this.error = true;
      })
    }
  }
}
</script>

<style scoped>

</style>
